import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import moment from "moment";

import VLFModal from "@/components/Modal";
import CreateSelectEntity from "@/components/CreateSelectEntity";
import VLFDatePicker from "@/components/Input/DatePicker";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFTextField from "@/components/Input/TextField";

import {PlayerAPI} from "@/api/player";

import {dateFormat, playerRoles} from "@/utils/constants";
import {checkRequiredFields, getTextField} from "@/utils/functions";
import {useTranslation} from "react-i18next";

function HandlePlayerModal(props) {
	const {open, initialData, confirm, close} = props;

	const seasonId = useSelector((state) => state?.season?.id);
	const {t} = useTranslation();

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	const [saveOption, setSaveOption] = useState(initialData ? "select" : "new");

	const [players, setPlayers] = useState([]);
	const getPlayers = async () => {
		try {
			const response = await PlayerAPI.list({prospect: true, seasonId});
			setPlayers(response);
		} catch (error) {
			console.log(error);
		}
	};

	const createPlayer = async () => {
		try {
			const body = {
				firstName: formData?.firstName ? formData.firstName : "",
				lastName: formData?.lastName,
				dateOfBirth: formData?.dateOfBirth
					? moment(formData?.dateOfBirth).format("YYYY-MM-DD")
					: undefined,
				mainFoot: formData?.mainFoot,
				goalkeeper: formData?.playerPrimaryRole?.value === "Portiere",
				primaryRole: formData?.playerPrimaryRole?.value,
				prospect: true,
			};

			const response = await PlayerAPI.create(body);
			return response;
		} catch (error) {
			console.log(error);
		}
	};

	const getRequiredFields = () => {
		if (saveOption === "select") {
			return ["player"];
		} else {
			return ["lastName", "playerPrimaryRole"];
		}
	};

	useEffect(() => {
		getPlayers();
	}, []);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	const defaultTextField = {
		values: formData,
		setValues: setFormData,
		errors,
		setErrors,
	};

	const currentPlayer = players?.filter(
		(p) => p.id === formData?.player?.value,
	)?.[0];

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica informazione" : "Aggiungi informazione"}
			close={close}
			confirm={async () => {
				const errors = checkRequiredFields(getRequiredFields(), formData);
				setErrors(errors);

				if (!errors.length) {
					let playerData = {};
					if (saveOption === "new") {
						const playerResponse = await createPlayer();
						playerData = {playerId: playerResponse?.id};
					} else {
						playerData = {playerId: formData?.player?.value};
					}
					confirm({...playerData}, initialData?.id);
				}
			}}
			content={
				<div className="row">
					<div className="col-12">
						<CreateSelectEntity
							currentOption={saveOption}
							setCurrentOption={setSaveOption}
						/>
					</div>
					{saveOption === "new" ? (
						<>
							<div className="col-12 col-sm-6 col-xl-4">
								{getTextField({
									...defaultTextField,
									fieldKey: "firstName",
									label: t("name"),
								})}
							</div>
							<div className="col-12 col-sm-6 col-xl-4">
								{getTextField({
									...defaultTextField,
									fieldKey: "lastName",
									label: "Cognome",
									required: true,
								})}
							</div>
							<div className="col-12 col-sm-6 col-xl-4">
								<VLFDatePicker
									label="Data di nascita"
									value={formData.dateOfBirth}
									onChange={(value) => {
										setFormData({...formData, dateOfBirth: value});
									}}
									format="DD-MM-YYYY"
								/>
							</div>
							<div className="col-12 col-sm-6 col-xl-4">
								<VLFSelectNew
									options={playerRoles}
									sortOrder="descend"
									value={formData.playerPrimaryRole}
									onChange={(newValue) => {
										setFormData({
											...formData,
											playerPrimaryRole: newValue,
										});
									}}
									label="Ruolo"
									required
								/>
							</div>
							<div className="col-12 col-sm-6 col-xl-4">
								{getTextField({
									...defaultTextField,
									fieldKey: "mainFoot",
									label: "Piede principale",
								})}
							</div>
						</>
					) : (
						<>
							<div className="col-12 col-sm-4">
								<VLFSelectNew
									options={players.map((pp) => {
										return {
											value: pp.id,
											label: pp.firstName + " " + pp.lastName,
										};
									})}
									value={formData?.player}
									onChange={(newValue) => {
										setFormData({...formData, player: newValue});
									}}
									label="Giocatore"
									required
								/>
							</div>
							{formData?.player && (
								<div className="col-12 col-sm-4">
									<VLFDatePicker
										label="Data di nascita"
										value={
											currentPlayer && currentPlayer?.dateOfBirth
												? moment(currentPlayer?.dateOfBirth).format(dateFormat)
												: "---"
										}
										editable={false}
									/>
								</div>
							)}
							{formData?.player && (
								<div className="col-12 col-sm-4">
									<VLFTextField
										value={
											currentPlayer?.goalkeeper
												? "Portiere"
												: currentPlayer?.primaryRole
										}
										label="Ruolo"
										editable={false}
									/>
								</div>
							)}
						</>
					)}
				</div>
			}
		/>
	);
}

export default HandlePlayerModal;
